import { render, staticRenderFns } from "./UserSelect.vue?vue&type=template&id=0636a136"
import script from "./UserSelect.vue?vue&type=script&lang=js"
export * from "./UserSelect.vue?vue&type=script&lang=js"
import style0 from "./UserSelect.vue?vue&type=style&index=0&id=0636a136&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports